import { FC } from 'react';
import { Skeleton } from 'ui/skeleton';
import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const DynamicSkeleton = styled(Skeleton)`
  width: 100%;
  max-height: 100%;
  overflow: hidden;
`;

const LeftColumn = styled.div`
  display: grid;
  grid-template-rows: auto auto;
  gap: ${spacing.plusHalf};
  min-height: 0;
  overflow: hidden;
`;

const RightColumn = styled.div`
  height: 100%;
  min-height: 0;
  overflow: hidden;
`;

export const SkeletonWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto auto auto;
  gap: ${spacing.plusHalf};
  padding: ${spacing.plusHalf};
  min-height: 0;
  overflow: hidden;
`;

const SecondRow = styled.div`
  display: grid;
  grid-template-columns: 35% 65%;
  gap: ${spacing.plusHalf};
  min-height: 0;
  overflow: hidden;
  max-height: ${pxToRem(400)}; 
`;

export const STOContentSkeleton: FC = () => {
  return (
    <SkeletonWrapper>
      <DynamicSkeleton height={100} />
      <SecondRow>
        <LeftColumn>
          <DynamicSkeleton height={125} />
          <DynamicSkeleton height={275} />
        </LeftColumn>
        <RightColumn>
          <DynamicSkeleton height={400} />
        </RightColumn>
      </SecondRow>
      <DynamicSkeleton height={325} />
    </SkeletonWrapper>
  );
};
